<script>

    import {replace} from 'svelte-spa-router'
    import { springIn, springOut } from "svelte-helpers/spring-transitions";
    import { fade } from "svelte/transition";
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';

    const progress = tweened(0, {
		duration: 2500,
		easing: cubicOut
	});

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

    let dash_token = '';
	let mebot_img_url = null;
	let is_hatched = 0;
	let is_hatching = 0;
	let result = null;
    let m_id = "";
    let map_badge_n = 0;
    let news_badge_n = 0;
    let is_anon = 0;
    let is_splash = 0; //no splash screen
    let pl = ''; //post login

    let charged = Math.random() * 0.0025 + 0.0005;
    charged = 0.0008;
    const SPRING_IN = { stiffness: charged, damping: 0.0012 };
    const animateIn = (node) => {
	    const { duration, tickToValue } = springIn(-6, 0, SPRING_IN);
	    return {
		    duration: (is_hatched == 1 ? 50000 : 0),
		    css: (t) => `transform: translateY(${tickToValue(t)}px)`,
	    };
    };

    async function doPost() {

        let client_width = document.documentElement.clientWidth;
        console.log(client_width);

        const res = await fetch(
            "https://api.forever.today/?method=get_dash_user",
            {
                method: "POST",
                body: JSON.stringify({
                    dash_token,
                    client_width,
                    is_splash
                }),
            }
        );

        const json = await res.json();
        result = json;
        is_hatched = json.data.is_hatched;
        is_hatching = json.data.is_hatching;
        mebot_img_url = json.data.mebot_img_url;
        m_id = json.data.m_id;
        pl = json.data.pl;

        setCookie("mebot_img_url", mebot_img_url, 30);

        map_badge_n = json.data.map_badge_n;
		setCookie("map_badge_n", map_badge_n, 1);

        news_badge_n = json.data.news_badge_n;
        setCookie("news_badge_n", news_badge_n, 1);

        is_anon = json.data.is_anon;
		setCookie("is_anon", is_anon, 1);

        if (m_id != '') {
            setCookie("m_id", m_id, 1)
            //console.log('setting m_id cookie:' + m_id);
        }
        if (m_id == '') {
            //console.log('got m_id from cookie:' + getCookie('m_id'));
            m_id = getCookie('m_id');
        }
    }

    async function processLogin() {

        dash_token = token;

        if (token.length == 24) {

		const res = await fetch(
			"https://api.forever.today/?method=mebot_login",
			{
				method: "POST",
				body: JSON.stringify({
					token,
				}),
			}
		);
            console.log('log');
            const json = await res.json();
            dash_token = json.data.dash_token;
            is_splash = 1; //show mebots splash screen
        }

        progress.set(1)

        setCookie("m_dash_token", dash_token, 30)

        await doPost();

        if (pl == 'map' || page == 'map') {
            setCookie("section", 'map', 1);
            setCookie("map_badge_n", -1, 1);
            replace("/map/2/1");
            return;
        }

        if (pl == 'map3d' || page == 'city' || page == 'map3d') {
            setCookie("section", 'map', 1);
            setCookie("map_badge_n", -1, 1);
            if ((pl == 'map3d' || page == 'map3d') && m_id != '') {
                replace('/map42/2/1/' + m_id);
                return;
            }
            replace('/map42/2/1');
            return;
        }
    
        if (pl == 'news' || page == 1) {
            setCookie("section", 'news', 1);
            setCookie("news_badge_n", -1, 1);
            replace("/feed/2/1");
            return;
        }

        if (page != null) {
            if (page.length == 40) {
                setCookie("section", 'home', 1);
                console.log('redir to habitat: ' + page)
                replace('/habitat/2/' + page);
                return;
            }
        }

        if (is_anon == 1) {
            await sleep(100);
        } else {
            await sleep(2000);
        }
//        return;
        mebot_img_url = '';
        await sleep(300);

//        console.log('dash token ' + dash_token)
//        if (isNaN(dash_token)) {
//        } else {

        if (is_anon == 1) {
            replace("/map/2/1");
        } else {
            replace("/dash/" + dash_token + "/1");
        }
            //replace("/dash/1/1");
//        }
	}

    export let params = {};
    let token = params.t;
    let page = params.page;
    processLogin();

</script>

{#if mebot_img_url}

<center>
    <img
        style="border:none; margin-top: 30px;"
        src="/img/mebots_preview_sm.png"
        width="240px"
        height="74px"
        alt="Welcome to Mebots!"
    />
</center>
<br>
    <div in:fade={{ delay: 300 }} out:fade|local class="snake_row" style="user-select: none;">
	<center>
            <br>
			<div in:animateIn style="user-select: none;">
				<a href="/#/dash/{dash_token}/{m_id}"
					style="user-select: none;">
					<img style="user-select: none;"
						src={mebot_img_url}
						width="260px"
						height="260px"
						alt="meebot"
					/>
                </a>
			</div>
	</center>
    <br />
    <center>
        <table width=300px border=0 >
        <tr>
            <td colspan=3 align=center>
            <div class="vitals2 text-glow" style="white-space: nowrap;" >
                Social Games for Healthy Habits
            </div>
            </td>
        </tr>
        <tr>
            <td width=45px valign=middle></td>
            <td width=210px ><div class="outer"><div class="progress_inner" style="width: {$progress * 100}%"></div></div></td>
            <td width=45px valign=middle></td>
        </tr>
        <tr>
            <td colspan=3 align=center>
            <div class="vitals3 text-glow-electric" style="white-space: nowrap;" >
                ♾️
            </div>
            </td>
        </tr>
        </table>
    </center>
    </div>

{/if}

<style>

.progress_inner, .speed_factor_progress_inner, .outer {
	height: 2px;
	border-radius: 0px;
}

.progress_inner {
	background-color: #b3f8f5;
	display: block;
	box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
}

.text-glow {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: white;
}

.text-glow-electric {
	text-shadow: 0 0 10px rgba(64, 255, 249, 0.75),
			0 0 32px rgba(65, 246, 255, 0.88);
	font-family: arial;
	color: rgb(156, 255, 250);
}

.vitals2 {
	color: white;
	font-size: 14px;
}
.vitals3 {
	color: white;
	font-size: 24px;
}

.outer {
	margin: 0px;
	background-color: transparent;
	border: 0px;
}

</style>